export default __webpack_public_path__ + "static/me-small-dd77b516bd3c90810e7eba9fb12af9e4.png";